module.exports = __webpack_public_path__ + "9488d02b/img/share-action-icon.9c12578c.svg";